import React from 'react'
import Hero from '../components/pages/Hero'
import hero from '../assets/hospital-2026/hospital-exterior.jpg'
import Biography from '../components/pages/Biography'
import about from '../assets/hospital-2026/care-team-entrance.jpg'
import Departments from '../components/pages/Departmnet'
import HospitalGallery from '../components/pages/HospitalGallery'
import Carousel2 from './carousel'
import Doctor from '../components/pages/doctors'


const Home = () => {
  return (
    <>
    <Carousel2/>
      <Hero  title={
          "Welcome to Sea be Cure Multi Super Speciality Hospital  | Your Trusted Healthcare Provider"
        }
        imageUrl={hero} imageAlt="Sea Be Cure Multi Super Speciality Hospital building"/>
        <Biography imageUrl={about} imageAlt="Our care team at the hospital entrance" />
        <Doctor />
        <Departments/>
        <HospitalGallery/>
        {/* <MessageForm/> */}
        
    </>
  )
}

export default Home
